import { render, staticRenderFns } from "./sealNav.vue?vue&type=template&id=71f05e70&scoped=true"
import script from "./sealNav.vue?vue&type=script&lang=js"
export * from "./sealNav.vue?vue&type=script&lang=js"
import style0 from "./sealNav.vue?vue&type=style&index=0&id=71f05e70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f05e70",
  null
  
)

export default component.exports